import React, { useEffect, useRef } from "react";

const ProcessedContent = ({ content, className = "" }) => {
  const contentRef = useRef(null);

  useEffect(() => {
    // After content is rendered, we can let the browser process it
    // This ensures Tailwind classes in the WordPress content are applied
    if (contentRef.current) {
      // This forces a reflow which helps with class processing
      // eslint-disable-next-line no-unused-expressions
      contentRef.current.offsetHeight;
    }
  }, [content]);

  return (
    <div 
      ref={contentRef}
      className={className}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default ProcessedContent; 